import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CrmService } from 'src/home/crm/services/crm.service';
import { HomeService } from 'src/home/home.service';
import { Contact } from 'src/models/Contacts.interface';

@Component({
  selector: 'app-create-contact',
  templateUrl: './create-contact.component.html',
  styleUrls: ['./create-contact.component.css']
})
export class CreateContactComponent {

  contactForm!: FormGroup;
  successMessage: string = '';
  errorMessage: string = '';

  constructor(
    private homeService: HomeService,
    private fb: FormBuilder,
    private crmService: CrmService,
    public dialogRef: MatDialogRef<CreateContactComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      clientCode: [0, Validators.required],
      familyId: [0, Validators.required],
      email: ['', [Validators.required, Validators.email]],
      state: ['', Validators.required]
    });
  }



  onSubmit() {
    if (this.contactForm.valid) {
      const contact: Contact = this.contactForm.value;
      this.crmService.createContact(contact).subscribe(
        response => {
          this.successMessage = 'Contact created successfully!';
          this.dialogRef.close(true);
        }
      );
    }
  }


  closeModal(): void {
    this.dialogRef.close(false);
  }
}
